// Textos y reglas de tareas y entregas que comparten el portal y el editor (docs/AULAS.md, «Estados de una entrega»).
import { fmtNum } from './ui/html.js';

export function gradeText(grade, points) {
  return `${fmtNum(grade)} / ${fmtNum(points)}`;
}

/** Etiqueta y clase CSS (.state.<cls>) del estado de una entrega; `sub` puede ser null (sin empezar). */
export function submissionState(sub, points) {
  switch (sub && sub.state) {
    case 'working':
      return { label: 'En progreso', cls: 'working' };
    case 'submitted':
      return sub.late ? { label: 'Entregada tarde', cls: 'late' } : { label: 'Entregada', cls: 'submitted' };
    case 'graded':
      return { label: sub.grade === null || sub.grade === undefined ? 'Calificada' : `Calificada: ${gradeText(sub.grade, points)}`, cls: 'graded' };
    case 'returned':
      return { label: 'Devuelta para corregir', cls: 'returned' };
    default:
      return { label: 'Sin empezar', cls: 'none' };
  }
}

/** El alumno puede cambiar su trabajo y entregarlo. */
export const canEdit = (state) => state === 'working' || state === 'returned';
/** El maestro puede calificar o devolver. */
export const canGrade = (state) => state === 'submitted' || state === 'graded' || state === 'returned';
/** Falta que el alumno la entregue. */
export const isPending = (sub) => !sub || !sub.state || sub.state === 'working' || sub.state === 'returned';

/** ¿Ya pasó la fecha límite? */
export function isOverdue(dueAt, now = Date.now()) {
  return !!dueAt && Date.parse(dueAt) < now;
}

// Nombre de la placa: el campo `board` puede traer el tipo de pieza (arduino-uno) o el código de compilación (uno).
const BOARDS = {
  'arduino-uno': 'Arduino Uno',
  uno: 'Arduino Uno',
  'arduino-nano': 'Arduino Nano',
  nano: 'Arduino Nano',
  'arduino-mega': 'Arduino Mega 2560',
  mega: 'Arduino Mega 2560',
  'arduino-pro-mini': 'Arduino Pro Mini',
  promini5: 'Arduino Pro Mini (5 V)',
  promini3: 'Arduino Pro Mini (3.3 V)',
  attiny85: 'ATtiny85',
  attiny85pll: 'ATtiny85',
  'pi-pico': 'Raspberry Pi Pico',
  pico: 'Raspberry Pi Pico',
};

export function boardName(board) {
  return BOARDS[board] || '';
}

/** Placas para empezar una plantilla en blanco (tipo de pieza → nombre). */
export const BLANK_BOARDS = [
  ['arduino-uno', 'Arduino Uno'],
  ['arduino-nano', 'Arduino Nano'],
  ['arduino-mega', 'Arduino Mega 2560'],
  ['arduino-pro-mini', 'Arduino Pro Mini'],
  ['attiny85', 'ATtiny85'],
  ['pi-pico', 'Raspberry Pi Pico'],
];
